// Produce a cropped square JPEG blob from an image source + react-easy-crop's
// croppedAreaPixels. Standard react-easy-crop canvas approach. Output is sized to
// outputSize×outputSize (default 400) at ~0.9 quality — crisp and well under 5MB.
export default function getCroppedImg(imageSrc, pixelCrop, outputSize = 400) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = outputSize;
        canvas.height = outputSize;
        const ctx = canvas.getContext('2d');
        // Draw the selected crop region scaled into the square output canvas.
        ctx.drawImage(
          image,
          pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
          0, 0, outputSize, outputSize
        );
        canvas.toBlob(
          (blob) => (blob ? resolve(blob) : reject(new Error('Could not create image'))),
          'image/jpeg',
          0.9
        );
      } catch (err) {
        reject(err);
      }
    };
    image.onerror = () => reject(new Error('Failed to load image'));
    image.src = imageSrc;
  });
}
